class CellChunk {
  constructor(alias, headings, cells) {
    this._alias = alias; // string (e.g. 'p' for projects)
    this._headings = headings; // list of DataTableHeading objects
    this._cells = cells; // list of DataTableCell objects
    this._rowspan = 1;
  }

  alias() {
    return this._alias;
  }

  headings() {
    return this._headings;
  }

  cells() {
    return this._cells;
  }

  incrementRowspan() {
    this._rowspan++;
  }

  rowspan() {
    return this._rowspan;
  }
}

export default CellChunk;
